export default "__VITE_ASSET__CXM$BzI2__"